export default "__VITE_ASSET__DBRhGkS7__"